// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6052a9f8] .custom-input__extended .input-group .input-group-text {\n  background: #2DB782;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
